import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
// service
import { getFlight } from "../../../../utils/services/flight";
// components
import TableFlight from "../../Voo/tableFlight";
import ModalNewFlight from "../../Voo/ModalNewFlight";
import ActionButtonRounded from "../../../../components/Buttons/ActionButtonRounded";
import LoadingSkelentonTable from "../../../../components/loadingSkeletonTable";

export default function Flight(props) {
  const { idEvent, participants, user } = props;
  const [voo, setVoo] = useState([]);
  // modal
  const [modalNewFlight, setModalNewFlight] = useState(false);
  // loading
  const [loading, setLoading] = useState(false);

  function getDataFlight() {
    setLoading(true);
    getFlight({
      idEvent: idEvent,
      offset: 1,
      limit: 10,
      search: user.id,
      columnSearch: "id",
    })
      .then((res) => {
        if (
          res.message === "FLIGHTS_BY_EVENT" &&
          res.findOneFlightData.count > 0
        ) {
          setVoo(res.findOneFlightData.data);
        } else setVoo([]);
      })
      .catch(() => {
        toast.error("Erro ao carregar voos.");
      })
      .finally(() => {
        setLoading(false);
      });
  }

  useEffect(() => {
    if (user?.id) {
      getDataFlight();
    }
  }, [user.id]);

  return (
    <>
      {modalNewFlight && (
        <ModalNewFlight
          isOpen={modalNewFlight}
          toggle={() => setModalNewFlight(false)}
          idEvent={idEvent}
          data={getDataFlight}
          participants={participants}
          user={user}
        />
      )}

      <div className="my-3">
        <div className="d-flex justify-content-end">
          <ActionButtonRounded
            title="Adicionar Voo"
            onClick={() => setModalNewFlight(true)}
            className="btn-rounded waves-effect waves-light events-button-add mb-2"
          />
        </div>

        {loading ? (
          <LoadingSkelentonTable lines={5} cols={4} />
        ) : (
          <TableFlight
            voo={voo}
            idEvent={idEvent}
            data={getDataFlight}
            fromUsers={true}
          />
        )}
      </div>
    </>
  );
}
